export default __webpack_public_path__ + "static/media/dipromgo.ada0c151.jpg";